import React, { memo, useState } from "react";
import "./style.scss";
import { Button, Form, Input } from "antd";
import {
  isRequired,
  validatePassWordConfirm,
  validatePasswordLength,
} from "../fields/validator";
import { useTranslation } from "react-i18next";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { profile } from "../../services";
import { ACCESS_TOKEN, ROUTER_PATH, USER_INFO } from "../../common/constant";
import { localizeRouteKey } from "../../shared/helpers";

const ProfileChangePassword = memo((props: any) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showChangePassword, setShowChangePassWord] = useState(false);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    const query = {
      old_password: values.oldPassword,
      new_password: values.newPassword,
      new_password_confirm: values.newPasswordConfirm,
    };

    profile.profileChangePassword(query, (data, err) => {
      setLoading(false);
      if (data) {
        setMessage(t("point_status_success"));

        window.location.href = localizeRouteKey(ROUTER_PATH.SIGN_IN);

        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(USER_INFO);
      } else {
        setMessage(err.message);
      }
    });
  };

  return (
    <div className="component-container">
      <li
        className="sub-title kd-name-title-component btn-change-password"
        onClick={() => setShowChangePassWord(!showChangePassword)}>
        {t("request_change_password")}
      </li>

      {showChangePassword && (
        <Form
          className="kd-change-password-form-content center"
          size="large"
          name="changePassForm"
          labelCol={{ span: 10 }}
          labelAlign="left"
          onFinish={(values) => handleSubmit(values)}>
          <Form.Item
            className="kd-change-password-form-item"
            name="oldPassword"
            rules={[isRequired, validatePasswordLength]}
            label={t("field_password_old")}>
            <Input.Password
              className="input"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
          <Form.Item
            className="kd-change-password-form-item"
            name="newPassword"
            rules={[isRequired, validatePasswordLength]}
            label={t("field_password_new")}>
            <Input.Password
              className="input"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
          <Form.Item
            className="kd-change-password-form-item"
            name="newPasswordConfirm"
            rules={[validatePassWordConfirm]}
            label={t("field_password_confirm")}>
            <Input.Password
              className="input"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>

          <Form.Item noStyle>
            <span className="message">{message}</span>

            <Button
              className="kd-change-password-form-button"
              type="primary"
              htmlType="submit"
              loading={loading}>
              {t("btn_save")}
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
});

export default ProfileChangePassword;
